<li
  role="button"
  class="rounded-[4px] p-3 justify-normal items-center flex gap-2 bg-white cursor-pointer hover:bg-[#F1F5FD] transition-all"
  [ngClass]="{
    'cursor-pointer': !disabled,
    'cursor-not-allowed opacity-60': disabled,
    'rounded-t-none': !isFirst,
    'rounded-b-none': !isLast,
  }"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="!disabled || !tooltipText.length"
  (click)="clickOption()"
>
  <mat-icon fontSet="material-icons-outlined" class="text-[#808080] w-5 h-5 text-[20px] flex justify-center items-center">
    {{ icon }}
  </mat-icon>
  <span class="text-color-normal text-sm font-normal">
    {{ text }}
  </span>
</li>
